import { Database } from "@punchup/data/supabase.types";
import { SpecialRow } from "../../legacy/specials";
import { createClientComponentClient } from "../../supabase/client";
import { getApiClient } from "@punchup/utils/apiRegistry";

export async function getUserPaidSpecials(): Promise<SpecialRow[]> {
  const response = await getApiClient().get<{
    data: SpecialRow[];
  }>(`/api/v2/user/specials?paid=true`);
  return response.data;
}

export async function getUserPlaybackLocation(
  specialId: string
): Promise<number> {
  const supabase = createClientComponentClient<Database>();
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.user) {
    // If no user, return 0 as default
    return 0;
  }
  const response = await getApiClient().get<{
    data: number;
  }>(`/api/v2/user/specials/${specialId}/playback`);
  return response.data;
}

export async function updateUserPlaybackLocation(
  specialId: string,
  playbackLocation: number
): Promise<void> {
  const supabase = createClientComponentClient<Database>();
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.user) {
    // If no user, don't update the playback location
    return;
  }
  await getApiClient().put<{
    data: number;
  }>(`/api/v2/user/specials/${specialId}/playback`, { playbackLocation });
}
